export const TICKETS_SERVICE_ENDPOINTS = {
  getAssistedPass: (ticketId: string) => `${process.env.GATSBY_BASE_API}/assistedPass/${ticketId}`,
  getUnaccompaniedMinorTempFilesUrl: process.env.GATSBY_TEMP_FILES_URL ?? '',
  getTicketsConfig: `${process.env.GATSBY_BASE_API}/cbx/tickets/config`,
  updateAssistedPass: `${process.env.GATSBY_BASE_API}/assistedPassUpdateAssistedData`,
} as const;
